import { ENV } from '@/constants';
import { exploreSchemaItemList } from '../exploreSchema';

export const schemaObject_HDPhotoConverter = {
	'@context': 'https://schema.org',
	'@graph': [
		{
			'@type': 'WebPage',
			'@id': 'https://liftapp.ai/hd-photo-converter',
			name: 'HD Photo Converter — Online',
			description:
				'HD image converter that transforms photos into high resolution. AI-powered tool to convert and improve photo quality online — no watermarks, instant results.',
			url: 'https://liftapp.ai/hd-photo-converter',
			image: 'https://liftapp.ai/seo-image.webp',
			mainEntity: [
				{ '@id': 'https://liftapp.ai/hd-photo-converter#product' },
				{ '@id': 'https://liftapp.ai/hd-photo-converter#howto' },
				{ '@id': 'https://liftapp.ai/hd-photo-converter#benefits' },
				{ '@id': 'https://liftapp.ai/hd-photo-converter#faq' },
				{ '@id': 'https://liftapp.ai/hd-photo-converter#why-lift' },
				{ '@id': 'https://liftapp.ai/hd-photo-converter#explore-tools' },
				{ '@id': 'https://liftapp.ai/hd-photo-converter#all-in-one' },
			],
		},
		// product
		{
			'@type': 'Product',
			'@id': 'https://liftapp.ai/hd-photo-converter#product',
			name: 'HD Photo Converter — Online',
			description:
				'HD image converter that transforms photos into high resolution. AI-powered tool to convert and improve photo quality online — no watermarks, instant results.',
			url: 'https://liftapp.ai/hd-photo-converter',
			brand: {
				'@type': 'Brand',
				name: 'Lift',
			},
			aggregateRating: {
				'@type': 'AggregateRating',
				ratingValue: 4.8,
				reviewCount: 130000,
				bestRating: '5',
				worstRating: '1',
			},
			interactionStatistic: [
				{
					'@type': 'InteractionCounter',
					interactionType: { '@type': 'InstallAction' },
					userInteractionCount: 13000000,
				},
			],
		},
		// howto
		{
			'@type': 'HowTo',
			'@id': 'https://liftapp.ai/hd-photo-converter#howto',
			name: 'How it works',
			step: [
				{
					'@type': 'HowToStep',
					position: 1,
					name: 'Upload your photos',
					text: 'Choose a photo from your device or take one using Lift’s app',
				},
				{
					'@type': 'HowToStep',
					position: 2,
					name: 'Let AI convert to HD',
					text: "Lift's HD converter analyzes your image and intelligently upscales resolution, sharpness, and detail",
				},
				{
					'@type': 'HowToStep',
					position: 3,
					name: 'Customize adjustments',
					text: 'Fine-tune your image with easy-to-use editing tools',
				},
				{
					'@type': 'HowToStep',
					position: 4,
					name: 'Download and use',
					text: 'Download your image or publish it straight to your social feeds',
				},
			],
		},
		// benefit
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/hd-photo-converter#benefits',
			name: 'Who can benefit from HD Photo Converter',
			description:
				'Lift HD Photo Converter helps e-commerce sellers, content creators, marketers, and more improve image quality instantly with AI retouching.',
			itemListOrder: 'Unordered',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'HD image converter is perfect for anyone needing high-quality visuals',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'Content creators and influencers for professional-looking posts',
				},
				{
					'@type': 'ListItem',
					position: 3,
					name: 'Businesses and e-commerce sellers improving product visuals',
				},
				{
					'@type': 'ListItem',
					position: 4,
					name: 'Event planners preserving memories in crisp detail',
				},
				{
					'@type': 'ListItem',
					position: 5,
					name: 'Students or professionals can clarify scanned documents, screenshots, or images',
				},
				{
					'@type': 'ListItem',
					position: 6,
					name: 'Photographers can restore older or low-quality images effortlessly',
				},
				{
					'@type': 'ListItem',
					position: 7,
					name: 'This normal photo to hd photo converter bridges the gap between everyday snapshots and professional results, making HD quality accessible to everyone',
				},
			],
			image: {
				'@type': 'ImageObject',
				contentUrl:
					'https://liftapp.ai/_next/static/media/Landing_2.c4fe76ac.webp',
				name: 'Benefits from Photo Converter',
				description: 'Low-res portrait enhanced with sharp focus',
			},
		},

		// faq
		{
			'@type': 'FAQPage',
			'@id': 'https://liftapp.ai/hd-photo-converter#faq',
			mainEntity: [
				{
					'@type': 'Question',
					name: 'What is Lift HD Photo Converter?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Lift HD Photo Converter is a premium online tool that improves photo clarity, colour and resolution up to 4K in a single click.',
					},
				},
				{
					'@type': 'Question',
					name: 'How does the HD image converter work?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'HD image converter uses a two-step deep-learning process: first, a smart denoiser cleans blur and noise; next, a super-resolution model rebuilds lost pixels, boosts colours and sharpens edges all the way up to crisp 4K. Everything runs in the cloud, so you get pro-level photo quality with one click.',
					},
				},
				{
					'@type': 'Question',
					name: 'Can the HD pic converter handle old or damaged photos?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Absolutely. The photo HD converter is specially trained to work with vintage photos, scanned images, screenshots, and heavily compressed files. It removes artifacts, reduces noise, and converts them to HD quality that looks natural and clear.',
					},
				},
				{
					'@type': 'Question',
					name: 'Can I download the results without a watermark?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: "Absolutely. All images generated or edited in Lift can be exported without watermark when you're on the Pro plan. Download them in high-res PNG or JPG — ready for social media, print, ads, or e-commerce.",
					},
				},
			],
		},

		// why lift
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/hd-photo-converter#why-lift',
			name: "Why Lift's HD Photo Converter Stands Out",
			description:
				"Lift's HD Photo Converter provides professional results, AI accuracy, cross-platform support, and is budget-friendly.",
			itemListOrder: 'Unordered',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'Professional results',
					description:
						'Achieve studio-quality images without the need for complex tools',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'AI accuracy',
					description:
						'Smart algorithms deliver enhancements tailored to your specific image',
				},
				{
					'@type': 'ListItem',
					position: 3,
					name: 'Cross-platform support',
					description: 'Available on iOS, Android, and Web for seamless access',
				},
				{
					'@type': 'ListItem',
					position: 4,
					name: 'Budget-friendly',
					description:
						'Save on costly editing services with Lift’s affordable solution',
				},
			],
			image: {
				'@type': 'ImageObject',
				contentUrl:
					'https://liftapp.ai/_next/static/media/Landing_3.39cb7ef1.webp',
				name: 'Converted with Lift',
				description:
					'Converted to HD photo of a smiling friends on pink background',
			},
		},
		// explore
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/image-extender#explore-tools',
			name: 'Explore the AI tools',
			description:
				'A curated list of AI-powered tools for image generation, enhancement, background removal, and more – all available on Lift.',
			itemListOrder: 'Unordered',
			...exploreSchemaItemList,
		},

		{
			'@type': 'SoftwareApplication',
			'@id': 'https://liftapp.ai/hd-photo-converter#all-in-one',
			name: 'Try Lift – AI Content Creation Tools',
			description:
				'Your all-in-one tools to create, edit, and elevate your content. Create stunning content with AI tools, templates, and editing features effortlessly.',
			operatingSystem: 'iOS, Android, Web',
			applicationCategory: 'MultimediaApplication',
			url: `${ENV.LIFT_WEB_APP_URL}/sign-in?auto_login=true`,
			applicationSubCategory: 'Content Creation',
			publisher: {
				'@type': 'Organization',
				name: 'Lift',
				url: 'https://liftapp.ai',
			},
			potentialAction: [
				{
					'@type': 'ViewAction',
					name: 'Open Web App',
					target: `${ENV.LIFT_WEB_APP_URL}/sign-in?auto_login=true`,
				},
			],
		},

		{
			'@type': 'BreadcrumbList',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'Home',
					item: 'https://liftapp.ai',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'HD Photo Converter',
					item: 'https://liftapp.ai/hd-photo-converter',
				},
			],
		},
	],
};
